import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Author() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="flex flex-col md:flex-row gap-12 items-start">
        <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} className="w-full md:w-1/3 flex-shrink-0">
          <div className="rounded-2xl overflow-hidden border-4 border-white shadow-xl bg-slate-100">
            <img
              src="https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=800&auto=format&fit=crop"
              alt="Andrei Marius Ciomirtan"
              className="w-full h-auto object-cover grayscale hover:grayscale-0 transition-all duration-500"
            />
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="w-full md:w-2/3">
          <h1 className="text-4xl font-extrabold text-slate-900 mb-1">Andrei Marius Ciomirtan</h1>
          <p className="text-xl text-blue-600 font-medium mb-8">Author of Website Blueprint Foundation</p>

          <div className="prose prose-lg text-slate-600 mb-8">
            <p>
              Andrei Marius Ciomirtan is the author of Website Blueprint Foundation: Volume 1, a practical guide to planning, building, and owning a professional website.
            </p>
            <p>
              The book reflects a clear teaching philosophy: readers deserve honest guidance, not hype, and they should understand the reasons behind the steps they take.
            </p>
            <p>
              That philosophy shows up throughout the book's focus on ownership, clarity, standards, search readiness, accessibility, and long-term control. Rather than chasing shortcuts, the work is built around helping readers create websites that are useful, portable, durable, and fully theirs.
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6 mb-8">
            <p className="text-blue-900 font-medium italic leading-relaxed">
              "Technology should enable independence, not create dependency. Every recommendation in this book starts from that principle."
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/buy" className="inline-flex items-center justify-center gap-2 bg-blue-600 text-white px-7 py-3.5 rounded-lg font-bold hover:bg-blue-700 transition-colors">
              View the Book <SafeIcon icon={FiIcons.FiArrowRight} />
            </Link>
            <div className="flex gap-4 items-center">
              <a href="#" className="text-slate-500 hover:text-blue-600 transition-colors font-medium flex items-center gap-1.5">
                <SafeIcon icon={FiIcons.FiLinkedin} /> LinkedIn
              </a>
              <a href="#" className="text-slate-500 hover:text-blue-600 transition-colors font-medium flex items-center gap-1.5">
                <SafeIcon icon={FiIcons.FiTwitter} /> Twitter
              </a>
              <a href="#" className="text-slate-500 hover:text-blue-600 transition-colors font-medium flex items-center gap-1.5">
                <SafeIcon icon={FiIcons.FiGlobe} /> Website
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}